import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const DragAndDropSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 12 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 4.92969C0.897 4.92969 0 4.03269 0 2.92969C0 1.82669 0.897 0.929688 2 0.929688C3.103 0.929688 4 1.82669 4 2.92969C4 4.03269 3.103 4.92969 2 4.92969Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 11.9922C0.897 11.9922 0 11.0952 0 9.99219C0 8.88919 0.897 7.99219 2 7.99219C3.103 7.99219 4 8.88919 4 9.99219C4 11.0952 3.103 11.9922 2 11.9922Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 19.0703C0.897 19.0703 0 18.1733 0 17.0703C0 15.9673 0.897 15.0703 2 15.0703C3.103 15.0703 4 15.9673 4 17.0703C4 18.1733 3.103 19.0703 2 19.0703Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.04688 4.92969C7.94387 4.92969 7.04688 4.03269 7.04688 2.92969C7.04688 1.82669 7.94387 0.929688 9.04688 0.929688C10.1499 0.929688 11.0469 1.82669 11.0469 2.92969C11.0469 4.03269 10.1499 4.92969 9.04688 4.92969Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.04688 11.9922C7.94387 11.9922 7.04688 11.0952 7.04688 9.99219C7.04688 8.88919 7.94387 7.99219 9.04688 7.99219C10.1499 7.99219 11.0469 8.88919 11.0469 9.99219C11.0469 11.0952 10.1499 11.9922 9.04688 11.9922Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.04688 19.0703C7.94387 19.0703 7.04688 18.1733 7.04688 17.0703C7.04688 15.9673 7.94387 15.0703 9.04688 15.0703C10.1499 15.0703 11.0469 15.9673 11.0469 17.0703C11.0469 18.1733 10.1499 19.0703 9.04688 19.0703Z'
      fill='currentColor'
    />
  </svg>
);

export const DragAndDropIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DragAndDropSvg} {...props} />
);
